<template>
    <div>
        <b-col cols="12" class="mt-2">
        <PageTitle title="Área profissional" />
      </b-col>
          <b-col class="d-flex justify-content-end">
              <b-button
                variant="success"
                @click="$bvModal.show('modalProfission')"
              >
                Registrar profissão
              </b-button>
          </b-col>
    <b-col cols="12" class="mt-4">
        <b-table
            striped
            responsive
            hover
            :fields="table.headers"
            :items="table.records"
        >
            <template #cell(index)="data">
                {{ data.item.id }}
            </template>
            <template #cell(area)="data">
                {{ data.item.area }}
            </template>

            <template #cell(id_external)="data">
              {{ data.item.id_external }}
            </template>

            <template #cell(action)="data">
                    
                <div v-if="!data.item.isEdit">
                    <b-button
                        class="mr-3"
                        :disabled="data.item.is_enable ? true : false"
                        variant="primary"
                        @click="isEditProfession(data.item.id)"
                    >Editar</b-button>
                    <b-button
                        variant="danger"
                        @click="deleteProfessionalArea(data.item.id)"
                        :disabled="data.item.is_enable ? true : false"
                        >Deletar</b-button>
                </div>
                <div v-if="data.item.isEdit" class="input-group mb-3">
                        <label class="input-group-text" id="profission-name">Profissão</label>
                        <input class="form-control" type="text" v-model="editArea" aria-describedby="profission-name">
                        <b-button
                            @click="editProfessionalArea(data.item.id)"
                            variant="success"
                            class="ml-2"
                        >Salvar</b-button>
                        <b-button
                            @click="data.item.isEdit = false"
                            variant="warning"
                            class="ml-2"
                        >
                            Cancelar
                        </b-button>
                    </div>
            </template>
        </b-table>
    </b-col>
    <professional-shopkeeper-modal></professional-shopkeeper-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import ProfessionalShopkeeperModal from '../../views/lojista/ProfessionalShopkeeperModal.vue';

export default {
    mixins: [makeToast],
    components: {PageTitle, ProfessionalShopkeeperModal},
    data() {
        return {
            editArea: '',
            idArea: 0,
            table: {
                headers: [
                    {
                        key: 'index',
                        sortable: false,
                        thClass: 'd-none',
                        tdClass: 'd-none',
                    },
                    {
                        key: 'area',
                        label: 'Área',
                        sortable: false,
                    },
                    {
                        key: 'action',
                        label: 'Editar/Deletar',
                        sortable: false,
                    }
                ],
                records: []
            }
        }
    },

    computed: {
        ...mapState({
            dadosUsuario: (state) => state.dadosUsuario,
        }),
    },

    mounted() {
        this.getArea();
    },

    methods: {
        ...mapActions('shopkeeper', [
            'cathProfission',
            'createProfission',
            'editProfession',
            'deleteProfession'
        ]),
        getArea() {
            this.$store.dispatch('startLoader');
            this.$store
                this.cathProfission(this.dadosUsuario.id)
                .then((resp) => {
                    this.table.records = resp.data;
                })
                .catch(() => {
                    this.makeToast(
                        'Erro',
                        'Houve um erro ao trazer os dados, favor atualizar a página!',
                        'danger'
                    );
                    })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                });
        },

        isEditProfession(id) {
            const profession = this.table.records.find((x) => x.id == id);
            const index = this.table.records.indexOf(profession);
            this.$set(this.table.records[`${index}`], 'isEdit', true);
        },

        editProfessionalArea(id) {
            const data = {
                shopkeeperId: this.dadosUsuario.id,
                idArea: id,
                area: this.editArea,
            }

            if(!data.area) {
                this.makeToast(
                        'Erro',
                        'O campo "profissão" deve ser preenchido!',
                        'danger'
                    );
                return;
            }
            const profession = this.table.records.find((x) => x.id == id);
            const index = this.table.records.indexOf(profession);
            this.$set(this.table.records[`${index}`], 'isEdit', true);

            if('isEdit') {
                this.isEnabled = true;
            }

            this.$store.dispatch('startLoader');
            this.$store
                this.editProfession(data)
                .then(() => {

                })
                .catch(() => {
                    this.makeToast(
                        'Erro',
                        'Houve um erro ao atualizar os dados, favor tente novamente!',
                        'danger'
                    );
                    })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                    this.editArea = '';
                    this.getArea();
                });
        },

        deleteProfessionalArea(id) {
            const data = {
                idArea: id

            }
        this.$store.dispatch('startLoader');
        this.$store
            this.deleteProfession(data)
            .then(() => {

            })
            .catch(() => {
                this.makeToast(
                    'Erro',
                    'Houve um erro ao deletar o registro, favor tente novamente!',
                    'danger'
                );
                })
            .finally(() => {
                this.$store.dispatch('endLoader');
                this.editArea = '';
                this.getArea();
            });
        }
    }
}
</script>